import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import './BookingSavePage.css';
import CollapsibleGrid from '../CollapsibleGrid/CollapsibleGrid'; // Adjust the import path as necessary
import FetchService from '../../api/FetchService';
import dayjs from 'dayjs';
import 'dayjs/locale/nb'; // Import Norwegian locale file // Import dayjs
import LoadingOverlay from 'react-loading-overlay';
import OrderPlan from '../OrderPlans/OrderPlan';
import { isLoggedIn } from "../../api/NewLoginService";
import { Modal, Alert, Toast, ToastContainer } from 'react-bootstrap'




function BookingSavePage({ isAdminView = false }) {
        const [userObject, setUser] = useState(isLoggedIn());
        const [bookings, setBookings] = useState(null);
        const [error, setError] = useState(null);
        const [subCategories, setSubCategories] = useState([]);
        const [isLoading, setIsLoading] = useState(true);
        const [showDeleteModal, setShowDeleteModal] = useState(false);
        const [selectedRow, setSelectedRow] = useState(null);
        const [showPopup, setShowPopup] = useState(false);
        const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false); // confirmation modal



        const [searchQuery, setSearchQuery] = useState("");
        const [currentBooking, setCurrentBooking] = useState("");

        const [triggerBooking, setTriggerBooking] = useState("");
        const [showModalDone, setShowModalDone] = useState(false);
        const [showModalMessage, setShowModalMessage] = useState("");

        const [triggerBookingLoader, setTriggerBookingLoader] = useState(false);


        const navigate = useNavigate();


  
  const CategoryObjecy = (id) => {
      
      id = id || -1;
    let categoryObject = subCategories.filter(obj => obj.id == id);
    return categoryObject[0];   
    }   

  // Fetch data on component mount
  useEffect(() => {
      RefreshData();

  }, []);



    const RefreshData = async () => {
        setIsLoading(true);
        setSelectedRow(null);



        FetchService.GetAllBusinessSaved(userObject && userObject?.user?.userTypeId === 3 ? userObject?.user?.id : null)
            .then((val) => {
                

                val.data = val.data.map(obj => {

                    obj.name = " <span class='relative inline-block align-middle ml-1 mr-3 -mt-5 z-1'>" +
                        "<i class='ri-calendar-line text-sl  text-gray-700 align-middle'></i>" +
                        "<span class='absolute -bottom-9 -right-2 flex h-5 w-5 items-center justify-center " +
                        "rounded-full bg-orange-500 text-white text-ms font-semibold shadow'>" +
                        (obj.activities?.length ?? 0) +
                        "</span>" +
                        "</span>" +
                        "<span class='text-sl align-middle booking-name-box'>" + obj.bookingName + "</span>";




                    obj.bookingDateOrg = dayjs(obj.bookingDate).locale('nb').format('DD. MMMM YYYY').toUpperCase();


                    return obj;
                });

                setBookings(val);
                debugger;
                setIsLoading(false);
            })
            .catch((e) => {
                console.error(e);
                setError('Failed to fetch bookings');
                debugger;
                setIsLoading(false);
            });


        FetchService.GetAllSubCategories().then((data) => {
            try {

                if (subCategories.length > 0) return; // Skip fetching if subcategories already exist

                const formattedData = data.data.map(sub => ({
                    value: sub.name,
                    id: sub.id,
                    icon: sub.icon
                }));
                formattedData.push(
                    {
                        value: "EGEN PLANLAGT AKTIVITET",
                        id: "0",
                        icon: ""
                    }
                )

                setSubCategories(formattedData);

            } catch (error) {
                console.error("Error fetching subCategory:", error);
            }
        }).catch((e) => {
            console.error(e);
            setError('Failed to subcategory  bookings');
            debugger;
            setIsLoading(false);
        });

    }

    const handleSave = async () => {
        if (!currentBooking) return;

        
        setIsLoading(true);
        // console.log("Booking data from child:", currentBooking);

        try {
            // Decide add vs update
            let response;
                currentBooking.booking.BusinessSavedId = selectedRow?.businessSavedId;

            debugger;

            if (currentBooking.booking.activities.length > 0) {


                response = await FetchService.UpdateBusinessSavedRequest(currentBooking);

            }


            // console.log("Save response:", response);


            setShowPopup(false);

            // refresh parent grid/list here if needed
            RefreshData(); // <-- call your useEffect loader

            // simulate loading for 1.5 seconds (1500 ms)
            setTimeout(() => {
                debugger;
                setIsLoading(false);
            }, 1500);

            setShowModalDone(true);
            setShowModalMessage("Dine endringer har blitt lagret.");
        } catch (err) {
            console.error("Save failed:", err);
        }
    };



    const handleView = async (row) => {
        try {
            // console.log(`Viewing booking ${row.id}`);

            // Parse session data
            let selectedRow = JSON.parse(row.sessionData);

            // Prepare payload
            const payload = { widget: selectedRow.widget, imgData: '' };

            setIsLoading(true);
            // Await response from service
            const response = await FetchService.getWheelPPT(payload);

            if (response?.data) {
                const blob = new Blob([response.data], { type: "application/pdf" });
                const filename = response.headers?.['content-disposition']?.split('filename=')[1]?.split(';')[0]?.replace(/['"]/g, '') || 'Sosiale_aktiviteter_Funtlers.pdf';

                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                setTimeout(() => document.body.removeChild(link), 100);
                debugger;
                setIsLoading(false);
                return true;
            }
            throw new Error("Invalid API response");

        } catch (error) {
            console.error("Error in handleView:", error);
            debugger;
            setIsLoading(false);
        }
    };

    const handleEdit = (row) => {
        setSelectedRow(row);
        let session = JSON.parse(row.sessionData);
        sessionStorage.setItem("recommendState", JSON.stringify(session));
        setShowPopup(true);
    };

  
    const handleDelete = (row) => {
        // console.log(`Deleting booking ${row.id}`);
        setSelectedRow(row);
        setShowDeleteModal(true);
    };

    const handleBookingPopup = (row) => {
        setTriggerBooking(false);
        

        setSelectedRow(row);
        let session = JSON.parse(row.sessionData);
        sessionStorage.setItem("recommendState", JSON.stringify(session));
        setTriggerBooking(true);
        setTriggerBookingLoader(true);

    };



    const handleSaveChanges = () => {
        handleSave();
        // 👉 your save logic here
        setShowPopup(false);
        setShowConfirmSaveModal(false);
    };

    const handleCloseWithoutSave = () => {
        setShowPopup(false);
        setShowConfirmSaveModal(false);
    };

  const getStatusConfig = (status) => {
        const configs = {
            confirmed: { text: 'Godkjent', dotColor: '#10b981' },
            pending: { text: 'Pending', dotColor: '#f59e0b' },
            cancelled: { text: 'Avbrutt', dotColor: '#ef4444' },
            completed: { text: 'Fullført', dotColor: '#3b82f6' }
        };
        return configs[status.toLowerCase()] || { text: 'Ukjent', dotColor: '#6b7280' };
    }

    const getStatusTranslation= (status) => {
        const configs = {
            pending: "Avventer bekreftelse"
        };
        return configs[status.toLowerCase()].toUpperCase() || 'Ukjent';
    }

    const renderCollapsibleContent = (row) => {
        // Define SVG icons as reusable components
        const SaveIcon = () => (
            <svg
                width="17"
                height="17"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                <polyline points="17 21 17 13 7 13 7 21" />
                <polyline points="7 3 7 8 15 8" />
            </svg>
        );

        // Define SVG icons as reusable components
        const InfoIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12" y2="8" />
            </svg>
        );

        const CalendarIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
        );

        const ClockIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
            </svg>
        ); 

        const CityIcon = () => (
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {/* Globe outline (slightly thinner stroke) */}
                <circle cx="12" cy="12" r="9.5" />

                {/* Crosshair lines (subtle grid) */}
                <line x1="2" y1="12" x2="22" y2="12" /> {/* Equator */}
                <line x1="12" y1="2" x2="12" y2="22" /> {/* Prime Meridian */}

                {/* Curved latitude lines (more pronounced) */}
                <path d="M4 8a8 8 0 0 1 16 0" />  {/* Northern hemisphere */}
                <path d="M4 16a8 8 0 0 1 16 0" />  {/* Southern hemisphere */}

                {/* Optional: Small dots for key cities */}
                <circle cx="16" cy="9" r="0.75" fill="currentColor" />  {/* Top-right city */}
                <circle cx="8" cy="12" r="0.75" fill="currentColor" />  {/* Mid-left city */}
                <circle cx="14" cy="16" r="0.75" fill="currentColor" /> {/* Bottom-right city */}
            </svg>
        );

        const UsersIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
        );

        const PriceTagIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2l9 4.9V17L12 22l-9-4.9V7L12 2" />
                <path d="M13 17h.01" />
                <path d="M13 13.5h.01" />
                <path d="M13 10h.01" />
            </svg>
        );

        const MoneyIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
        );

        const MoneyBigIcon = () => (
            <div class="p-2 bg-green-100 rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign w-4 h-4 text-green-600" aria-hidden="true"><line x1="12" x2="12" y1="2" y2="22"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg></div>
        );

        const  colmd=  row?.city ? 'col-md-4' : 'col-md-6';

        const totalPrice = row.activities.reduce((acc, activity) => {
            return acc + (activity.personCount || 0) * (activity.pricePerPerson || 0);
        }, 0);

        return (
            <div className="p-3   ">
                {/* HEADER SECTION */}
                <div className="mb-4 p-2 bg-white  ">
                 
                    <h5 className=" text-muted uppercase bb-1 mb-3 p-2"><strong>AKTIVITETSDETALJER</strong></h5>
                  
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                       
                        <div>
                            <spam className="mb-1 d-flex align-items-center text-base">
                                <SaveIcon />
                                <span className="ms-2 fw-bold">{row.bookingName || 'Ukjent navn'}</span>
                            </spam>
                        </div>
                        <div className="mt-2 mt-md-0 text-base">
                            {/*<span*/}
                            {/*    className={`badge   p-2`}*/}
                            {/*    dangerouslySetInnerHTML={{*/}
                            {/*        __html: row.statusHeading || 'Ukjent status'*/}
                            {/*    }}*/}
                            {/*></span>*/}
                        </div>
                    </div>

                    <div className="row">
                        <div className={`${colmd} mb-2 mb-md-0`}>
                            <p className="mb-1 d-flex align-items-center">
                                <CalendarIcon />
                                <b className="ms-2">Dato:</b>
                                <span className="ms-2">
                                    {dayjs(row.bookingDate).locale('nb').format('DD. MMMM YYYY').toUpperCase()}
                                </span>
                            </p>
                        </div>
                        <div className={`${colmd}`}>
                            <p className="mb-1 d-flex align-items-center justify-content-center w-100">
                                <ClockIcon />
                                <b className="ms-2">Opprettet:</b>
                                <span className="ms-2">
                                    {dayjs(row.bookingDate).format('HH:mm').toUpperCase()}
                                </span>
                            </p>
                        </div>

                        {row.city && <div className={`${colmd}`}>
                            <p className="mb-1 d-flex align-items-center justify-content-center w-100">
                                                <CityIcon />
                                                 <b className="ms-2">By:</b>
                                                <span className="ms-2">
                                                  {(row?.city === "all" ? "Alle" : row?.city)?.toUpperCase()}
                                                </span>
                                            </p>
                                     </div>
                        }
                    </div>
                </div>

                {/* ACTIVITIES SECTION */}
                <h5 className="p-2 bg-white  shadow-sm d-flex align-items-center bb-1">
                    <UsersIcon />
                    <span className="ms-2">Aktiviteter ({row.activities.length})</span>
                </h5>

                <div className="bg-white row row2 bb-1" >
                    {row.activities.map((activity, index) => (
                        <div key={index} className=" col-md-6 mb-6">
                            <div className="d-flex align-items-start bg-white p-3  h-100">
                                <div className="searchResultContent flex-fill">
                                    <h6 className="mb-2 d-flex align-items-center">
                                        <InfoIcon />
                                        <b className="ms-2">
                                            {activity.activityName?.slice(0, 28)}
                                            {activity.activityName?.length > 28 ? '...' : ''}
                                        </b>
                                    </h6>

                                    <div className="ms-4">
                                        <p className="mb-2 d-flex align-items-center">
                                            <CalendarIcon />
                                            <b className="ms-2">Dato:</b>
                                            <span className="ms-2">
                                                {dayjs(activity.activityDate).locale('nb').format('DD. MMMM YYYY').toUpperCase()}
                                            </span>
                                        </p>

                                        <p className="mb-2 d-flex align-items-center">
                                            <ClockIcon />
                                            <b className="ms-2">Tid:</b>
                                            <span className="ms-2">
                                                {activity.timeFrom.slice(0, 5)|| 'N/A'} - {activity.timeTo.slice(0, 5) || 'N/A'}
                                            </span>
                                        </p>

                                        <p className="mb-2 d-flex align-items-center">
                                            <UsersIcon />
                                            <b className="ms-2">Personer:</b>
                                            <span className="ms-2">{activity.personCount}</span>
                                        </p>
                                        {
                                            activity?.category && <p className="mb-2 d-flex align-items-center">
                                                <UsersIcon />
                                                <b className="ms-2">Kategori:</b>
                                                <span className="ms-2">{CategoryObjecy(activity.category)?.value}</span>
                                            </p>

                                        }

                                        <p className="mb-2 d-flex align-items-center">
                                            <PriceTagIcon />
                                            <b className="ms-2">Pris per person:</b>
                                            <span className="ms-2">{activity.pricePerPerson} NOK</span>
                                        </p>

                                        <p className="mb-0 d-flex align-items-center">
                                            <MoneyIcon />
                                            <b className="ms-2">Total aktivitet:</b>
                                            <span className="ms-2">
                                                {(activity.personCount || 0) * (activity.pricePerPerson || 0)} NOK
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* TOTAL COST SECTION */}
                    <div className="bg-green p-3    align-items-center mt-1 p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-200">
                        <h5 className="mb-0 d-flex align-items-center justify-content-center">
                            <MoneyBigIcon/>
                            <b className="ms-2">Total kostnad:</b>
                            <span className="ms-2 text-green-600">{totalPrice} NOK</span>
                        </h5>
                    </div>
                </div>

                {/* ADDITIONAL INFORMATION SECTION */}
                {/*<h5 className="mt-4 p-2 bg-white  shadow-sm d-flex align-items-center bb-1">*/}
                {/*    <InfoIcon />*/}
                {/*    <span className="ms-2">Tilleggsinformasjon</span>*/}
                {/*</h5>*/}

                {/*<div className="bg-white p-3  shadow-sm mb-4">*/}
                {/*    {row.additionalInfo ? (*/}
                {/*        <p className="mb-0">{row.additionalInfo}</p>*/}
                {/*    ) : (*/}
                {/*        <p className="mb-0 text-muted fst-italic">Ingen tilleggsinformasjon oppgitt</p>*/}
                {/*    )}*/}
                {/*</div>*/}


            </div>
        );
    };




  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
      <div className="booking-details-page admin_landingpage">
        <LoadingOverlay
            active={isLoading || triggerBookingLoader}
            spinner
            text="Behandler forespørselen din"
        ></LoadingOverlay>

      <div className="booking-wrapper">
              <header className="booking-header">
                  <div></div>
                  <h1
                      className={
                          isAdminView
                              ? "form_heading inner_header_main fw-bold"
                              : "text-center admin_heading fw-bold"
                      }
                  >
                      LAGREDE AKTIVITETER
                  </h1>
                  <p
                      className={
                          isAdminView
                              ? "booking-subtitle text-start text-uppercase"
                              : "d-flex justify-content-center text-uppercase-subheading"
                      }
                  >
                      {isAdminView ?
                          'Her finner du aktiviter og kalendere som B2B kunder har lagret tidligere I sine egne profiler. Disse er ikke bestilt enda, men gir et overblikk på hva kundene vurderer.' :
                          'Her finner du aktiviter og kalendere du har lagret tidligere. Du kan redigere, slette eller sende inn forespørsel om booking direkte fra listen.'}
                  </p>
              </header>
        {/* Render grid only if bookings data is available */}
              {bookings && (
                  <div style = {{ zoom: 0.94 }}>
                      <CollapsibleGrid
                        uniquieid={"businessSavedId"}
                        columnstranslate={["LAGRET AKTIVITET ", "DATO LAGRET","LAGRET AV"]}
                        columns={["name", "bookingDateOrg", "email"]}
                        data={bookings.data}
                        actions={[
                            {
                                label: "VIS LAGRET",
                                icon: "eye",
                                className: "view-button",
                                onClick: (row) => handleView(row),
                            },
                            {
                                label: "REDIGER",
                                icon: "edit",
                                className: "edit-button",
                                onClick: (row) => handleEdit(row),
                            },
                            {
                                label: "SLETT",
                                icon: "trash",
                                className: "delete-button",
                                onClick: (row) => handleDelete(row),
                            },
                            {
                                label: "FORESPØR BOOKING",
                                icon: "calendar-check",
                                className: "calendar-button",
                                onClick: (row) => handleBookingPopup(row),
                            },

                        ]}
                        renderExpandedContent={renderCollapsibleContent}
                        expandMode="single" // or 'multiple'
                      />
                  </div>
        )}
          </div>
  

          {showDeleteModal && (
              <Modal 

                  backdrop="static"          // Prevent closing when clicking outside
                  keyboard={false}           // Prevent closing when pressing ESC
                  centered
                  show={showDeleteModal}
                  onHide={() => setShowDeleteModal(false)}
              >
                  <Modal.Header closeButton>
                      <Modal.Title>Bekreft sletting</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                      <p className="text-gray-600 mb-6">
                          Er du sikker på at du vil slette den lagrede aktiviteten?
                      </p>
                  </Modal.Body>

                  <Modal.Footer>
                      <button
                          className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-700"
                          onClick={async () => {
                              try {
                                  setIsLoading(true);

                                  const response = await FetchService.SendBusinessDeleteRequest({
                                      Id: selectedRow.businessSavedId,
                                  });
                                  // // console.log("Delete response:", response);
                                  RefreshData();
                                  setShowDeleteModal(false);
                                  debugger;
                                  setIsLoading(false);
                              } catch (error) {
                                  console.error("Error deleting:", error);
                                  debugger;
                                  setIsLoading(false);
                              }
                          }}
                      >
                          JA
                      </button>
                      <button
                          className="px-4 py-2 rounded-lg bg-gray-200  text-black hover:bg-gray-300"
                          onClick={() => setShowDeleteModal(false)}

                      >
                          NEI
                      </button>
                  </Modal.Footer>
              </Modal>


          )}

          {showPopup && (<>
              <div className="overlay-pop">
                  <div className="modal-pop modal-edit">
                      {/* Close button pinned on top */}
                      <div className="close-button">
                          <button
                              className="close-btn"
                              onClick={() => {
                                  setShowPopup(true);
                                  setShowConfirmSaveModal(true);
                              }}
                          >
                              ✖
                          </button>
                      </div>


                      {/* Scrollable content */}
                      <div className="p-cstm-17  overflow-y-auto overflow-x-hidden flex-1">
                          <OrderPlan
                              searchQuery={searchQuery}
                              setSearchQuery={setSearchQuery}
                              editButtons={null}
                              action={JSON.parse(selectedRow.sessionData)?.action}
                              bookingName={selectedRow?.bookingName}
                              className="scale-[0.8]"
                              onChangeUpdate={(updatedData) => {
                                  // 👈 this will fire every time child updates something
                                  // // console.log("Booking data from child:", updatedData);
                                  setCurrentBooking(updatedData); // store it in parent state
                              }}
                              isEditMode={true}

                              EditData={{
                                  heading: "Rediger aktivitetsdetaljer",
                                  description:
                                      " Her kan du se gjennom og oppdatere alle aktivitetsdetaljer. Vennligst sjekk informasjonen nøye, og gjør eventuelle endringer før du sender inn en bookingsforespørsel.",
                                  Mode: "isEditSave",
                              }}


                              onSave={() => {
                                  //setShowPopup(false);
                                  //setIsLoading(true);
                                  //FetchService.SendBusinessDeleteRequest({
                                  //    Id: selectedRow.businessSavedId,   // ✅ use row directly
                                  //}).then((response) => {        // ✅ fixed arrow function

                                  //        RefreshData();
                                  //        setShowModalDone(true);
                                  //        setShowModalMessage("Din bookingforespørsel har blitt sendt inn.");
                                  //});

                                  setShowPopup(false);
                                  setIsLoading(true);
                                  handleSaveChanges();
                              }}
                          />
                      </div>
                  </div>
              </div>
              {/* Confirm Save Modal */}
           
              </>
          )}

          {triggerBooking && 

              <OrderPlan
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              editButtons={null}
              action={JSON.parse(selectedRow?.sessionData)?.action}
              className="scale-[0.8]"
              triggerRequestBooking={true}
              bookingName={selectedRow?.bookingName}
              onBookingUpdate={async (updatedData) => {

                  debugger;
                  // 👈 mark it async
                  // // console.log("Booking data from child:", updatedData);

                  if (updatedData) {
                      try {
                          setIsLoading(true);

                          const response = await FetchService.SendBusinessDeleteRequest({
                              Id: selectedRow.businessSavedId,
                          });
                     

                          // console.log("Delete response:", response);
                          setShowDeleteModal(false);
                          setTriggerBooking(false);


                          setShowModalDone(true);
                          setShowModalMessage(
                              "Din bookingforespørsel har blitt sendt. Funtlers vil svare innen 5 arbeidsdager, eller raskere dersom aktivitetsdatoen nærmer seg. Dersom noe haster er du også velkommen til å kontakte oss på <a href='mailto:support@funtlers.com' class='underline' style='display: contents;'>support@funtlers.com</a>."
                          );     


                          setTimeout(() => {
                              RefreshData();
                              setTriggerBookingLoader(false);

                          }, 700); // 200ms delay


                      } catch (error) {
                          console.error("Error deleting:", error);
                      }
                      //finally {
                      //    setIsLoading(false); // ✅ always reset loading
                      //}
                  }
              }}
              onBookingClose={async (updatedData) => {
                  setTriggerBooking(false);
                  setSelectedRow(null);
                  sessionStorage.setItem("recommendState", null);
                  setIsLoading(false);
                  setTriggerBookingLoader(false);
                  setShowModalMessage("");

              //    setShowModalDone(true);
              //    setShowModalMessage("Din bookingforespørsel har blitt sendt inn.");
              }}
                 

              />
              
          }





          <Modal
              show={showConfirmSaveModal}
              onHide={() => setShowConfirmSaveModal(false)}
              centered
              backdrop="static"
          >
              <Modal.Header closeButton>
                  <Modal.Title>LAGRE ENDRINGER?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  Vil du lagre endringene før du lukker?
              </Modal.Body>
              <Modal.Footer>

                  <button className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-700" onClick={handleSaveChanges}>
                      Ja
                  </button>

                  <button className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-700" onClick={handleCloseWithoutSave}>
                      Nei
                  </button>
                
              </Modal.Footer>
          </Modal>


          {showModalDone &&
              <div
                  style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0,0,0,0.5)", // 🔹 background overlay
                      zIndex: 6999, // just under the alert
                  }}
              >
                  <Alert className="col-md-5" style={{
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 7000
                  }}
                      show={showModalDone} variant="success">
                      <p
                          className=" text-gray-700 leading-relaxed flex-wrap items-center"
                          style={{ whiteSpace: "normal", wordBreak: "break-word", display:"inline-block" }}
                          dangerouslySetInnerHTML={{ __html: showModalMessage }}
                      ></p>


                      <hr />
                      <div className="d-flex justify-content-end">
                          <button className="btnOrder" onClick={() => { setShowModalDone(false) }} variant="outline-success">
                              LUKK
                          </button>
                      </div>
                  </Alert>
              </div>
          }

    </div>
  );
}

export default BookingSavePage;